import { InputField } from 'components-new'
import { availableCountriesAndCurrencies } from 'components-new/inputs/CurrencyAutocomplete/CurrencyAutocomplete.model'
import { useCountryPolicy } from 'pages/advanced-credit-policy/CountryPolicyProvider'
import React from 'react'

const ShortTermDebtInput = ({ isAdvanced = true }) => {
  const { policy, setPolicy, isInferiorPlan, selectedCountry } = useCountryPolicy()
  const defVal = policy.short_term_debt ?? 0
  const [val, setVal] = React.useState<number>(defVal)

  const currency = availableCountriesAndCurrencies?.filter(
    (countryCurr) => countryCurr.country === selectedCountry?.toUpperCase()
  )[0]

  // this is needed to set the initial value after it's been null
  React.useEffect(() => {
    if (typeof policy.short_term_debt === 'number') {
      setVal(policy.short_term_debt)
    }
  }, [policy.short_term_debt])

  return (
    <InputField
      value={val}
      addOn={currency?.currency}
      handleChange={function (value: string): void {
        if (isNaN(Number(value))) return
        setVal(Number(value))
        setPolicy({ ...policy, short_term_debt: Number(value) })
      }}
      disabled={isAdvanced && isInferiorPlan}
    />
  )
}

export default ShortTermDebtInput
